export type CustomerEmail = {
  address: string
  isPrimary: boolean
}

export const defaultCustomerEmail = (): CustomerEmail => ({
  address: '',
  isPrimary: false
})

export const getBestCustomerEmail = (emails: CustomerEmail[]): string | undefined => {
  return emails.find(x => x.isPrimary)?.address ?? emails[0]?.address
}
